/**
 * SafeChlor — Product Carousel JS
 * Handles: slide navigation, dots, auto-play, touch/swipe, resize
 */
(function () {
  'use strict';

  function initCarousel(section) {
    var id      = section.id.replace('product-carousel-', '');
    var handle  = id.replace(/-/g, '_');
    var track   = section.querySelector('[id^="pc-track-"]');
    var prevBtn = section.querySelector('[id^="pc-prev-"]');
    var nextBtn = section.querySelector('[id^="pc-next-"]');
    var dotsWrap = section.querySelector('[id^="pc-dots-"]');

    if (!track) return;

    var cards       = Array.from(track.querySelectorAll('.pc__card'));
    var total       = cards.length;
    var current     = 0;
    var autoTimer   = null;
    var autoPlay    = window['__pcAutoPlay_' + handle] || false;
    var autoDelay   = window['__pcAutoDelay_' + handle] || 4000;

    /* ── Visible count based on viewport ── */
    function getVisible() {
      var w = window.innerWidth;
      if (w <= 540)  return 1;
      if (w <= 860)  return 2;
      if (w <= 1200) return 3;
      return 4;
    }

    /* ── Step width (card + gap) ── */
    function getStep() {
      if (cards.length < 2) return 0;
      return cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
    }

    /* ── Max index ── */
    function getMax() {
      return Math.max(0, total - getVisible());
    }

    /* ── Build dots ── */
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var pages = getMax() + 1;
      for (var i = 0; i < pages; i++) {
        var btn = document.createElement('button');
        btn.className = 'pc__dot' + (i === current ? ' pc__dot--active' : '');
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-selected', i === current ? 'true' : 'false');
        btn.setAttribute('aria-label', 'Page ' + (i + 1));
        btn.dataset.page = i;
        btn.addEventListener('click', function () { go(parseInt(this.dataset.page)); });
        dotsWrap.appendChild(btn);
      }
    }

    /* ── Update dots ── */
    function updateDots() {
      if (!dotsWrap) return;
      Array.from(dotsWrap.querySelectorAll('.pc__dot')).forEach(function (d, i) {
        d.classList.toggle('pc__dot--active', i === current);
        d.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });
    }

    /* ── Go to index ── */
    function go(idx) {
      var max = getMax();
      current = Math.max(0, Math.min(idx, max));
      track.style.transform = 'translateX(-' + (current * getStep()) + 'px)';
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current >= max;
      updateDots();
    }

    /* ── Auto play ── */
    function startAuto() {
      if (!autoPlay) return;
      autoTimer = setInterval(function () {
        go(current >= getMax() ? 0 : current + 1);
      }, autoDelay);
    }
    function stopAuto() { clearInterval(autoTimer); }

    /* ── Arrow buttons ── */
    if (prevBtn) prevBtn.addEventListener('click', function () { stopAuto(); go(current - 1); startAuto(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stopAuto(); go(current + 1); startAuto(); });

    /* ── Touch / swipe ── */
    var touchX = 0;
    track.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var diff = touchX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) { stopAuto(); go(diff > 0 ? current + 1 : current - 1); startAuto(); }
    }, { passive: true });

    /* ── Pause auto on hover ── */
    section.addEventListener('mouseenter', stopAuto);
    section.addEventListener('mouseleave', startAuto);

    /* ── Resize ── */
    var ro = new ResizeObserver(function () { buildDots(); go(current); });
    ro.observe(section);

    /* ── Init ── */
    buildDots();
    go(0);
    startAuto();
  }

  /* ── Bootstrap ── */
  function init() {
    document.querySelectorAll('[id^="product-carousel-"]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Shopify Theme Editor live reload */
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.querySelector('[id^="product-carousel-"]');
    if (sec) initCarousel(sec);
  });

})();
